import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { PortalLayout } from './components/PortalLayout';
import { HomeRedirect } from './components/HomeRedirect';
import { ProtectedRoute } from './components/ProtectedRoute';
import { PortalDossiersPage } from './features/portal/PortalDossiersPage';
import { PortalDossierPage } from './features/portal/PortalDossierPage';
import { PhotoPolicyPage } from './features/admin/PhotoPolicyPage';
import { ExifPolicyPage } from './features/admin/ExifPolicyPage';
import { LoginPage } from './features/auth/LoginPage';
import { MandantsListPage } from './features/mandants/MandantsListPage';
import { MandantDetailPage } from './features/mandants/MandantDetailPage';
import { DossiersListPage } from './features/dossiers/DossiersListPage';
import { DossierDetailPage } from './features/dossiers/DossierDetailPage';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { ReferentielsPage } from './features/referentiels/ReferentielsPage';

/**
 * Route table for the DERLIZ web SPA. Router provider (BrowserRouter / MemoryRouter)
 * is supplied by the caller (main.tsx in prod, tests in unit tests), which keeps
 * this component trivially testable.
 */
export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/mandants" element={<MandantsListPage />} />
          <Route path="/mandants/:id" element={<MandantDetailPage />} />
          <Route path="/dossiers" element={<DossiersListPage />} />
          <Route path="/dossiers/:id" element={<DossierDetailPage />} />
          <Route path="/referentiels" element={<ReferentielsPage />} />
          <Route path="/admin/photos" element={<PhotoPolicyPage />} />
          <Route path="/admin/privacy" element={<ExifPolicyPage />} />
        </Route>
        {/* LOT B3 — portail client (coquille minimale, lecture seule). */}
        <Route element={<PortalLayout />}>
          <Route path="/portail" element={<PortalDossiersPage />} />
          <Route path="/portail/dossiers/:id" element={<PortalDossierPage />} />
        </Route>
        {/* Accueil authentifié : route selon le rôle (client → portail, interne → back-office). */}
        <Route path="/" element={<HomeRedirect />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
